import $ from 'jQuery';
import { modal } from './machine_app_modal';
import { gMachineAppExplanationText, gMachineAppViews } from '../machine_app_global_variables';
import machine_app_implementation_loader from '../models/machine_app_implementation_loader';
import './machine_app_learn_more_modal.css';

export function learnMoreModal(
  pOpenMachineApp,
  pDefinition,
  pHasStartedSetup,
) {
  const lModal = modal({ closeOnOutsideClick: true });

  const lLearnMoreCloseButtonContainer = $("<div>")
    .addClass('machine_app_confirmation_modal_close_button_container')
    .on('click', () => lModal.hide());

  const lLearnMoreCloseButton = $('<i>')
    .addClass('icon-close');

  const lLearnMoreContent = getLearnMoreContent(
    pOpenMachineApp,
    pDefinition,
    pHasStartedSetup,
    lModal,
  );

  lModal.content
    .css({position: "relative"})
    .append(
      lLearnMoreCloseButtonContainer.append(
        lLearnMoreCloseButton,
      ),
      lLearnMoreContent,
    );

  lModal.show();
}

function getLearnMoreContent(
  pOpenMachineApp,
  pDefinition,
  pHasStartedSetup,
  pModal,
) {
  const lOptionalUiHooks = machine_app_implementation_loader.instance.getOptionalUiHooks(pDefinition.getType());
  const lContentContainer = $('<div>')
    .addClass('machine_app_learn_more_content_container');
  const lTopSection = $('<div>')
    .addClass('machine_app_learn_more_top_section');
  const lGetStartedSection = getGetStartedSection(pOpenMachineApp, pHasStartedSetup, pModal, lOptionalUiHooks);
  const lGetInformationSection = getInformationSection(pDefinition);
  const lEasyStepsSection = getEasyStepsSection(pDefinition, lOptionalUiHooks);

  return lContentContainer.append(
    lTopSection.append(
      lGetStartedSection,
      lGetInformationSection
    ),
    lEasyStepsSection
  );
}

function getGetStartedSection(pOpenMachineApp, pHasStartedSetup, pModal, pOptionalUiHooks) {
  const lGetStartedContainer = $('<div>')
    .addClass('machine_app_learn_more_getting_started_container');
  const lThumbnail = $('<div>')
    .addClass('machine_app_learn_more_thumbnail')
    .append(pOptionalUiHooks.getThumbnail && pOptionalUiHooks.getThumbnail());
  const lGetStartedButton = $('<button>')
    .addClass('machine_app_learn_more_button')
    .addClass('machine_app_learn_more_get_started_button')
    .append($('<span>').text('Get Started - Configure Machine'))
    .on('click', () => {
      pModal.hide();
      pOpenMachineApp();
    });

  if(pHasStartedSetup) {
    lGetStartedButton
      .removeClass('machine_app_learn_more_get_started_button')
      .addClass('machine_app_learn_more_continue_button')
      .text('Continue Setup');
  }

  return lGetStartedContainer.append(
    lThumbnail,
    lGetStartedButton
  );
}

function getInformationSection(
  pDefinition
) {
  const lFlavorText = machine_app_implementation_loader.instance.getFlavorText(pDefinition.getType());
  const lInformationContainer = $('<div>')
    .addClass('machine_app_learn_more_information_container');
  const lGeneralInfoHeader = 'What are MachineApps?';
  const lGeneralInfoText = gMachineAppExplanationText;
  const lSpecificAppHeader = lFlavorText.learnMoreModal.title;
  const lSpecificAppText = lFlavorText.learnMoreModal.description;
  const getParagraph = (pHeader, pText) => {
    return $('<div>')
      .addClass('machine_app_learn_more_paragraph_container')
      .append(
        $('<label>')
          .addClass('machine_app_learn_more_section_header')
          .html(pHeader),
        $('<p>')
          .html(pText)
      );
  };

  return lInformationContainer.append(
    $('<p>')
      .addClass('machine_app_learn_more_title_general')
      .text('Vention MachineApps'),
    $('<h2>')
      .text(pDefinition.getName()),
    getParagraph(lGeneralInfoHeader, lGeneralInfoText),
    getParagraph(lSpecificAppHeader, lSpecificAppText)
  );
}

function getEasyStepsSection(pDefinition, pOptionalUi) {
  const pFlavorText = machine_app_implementation_loader.instance.getFlavorText(pDefinition.getType());
  const lEasySteps = pOptionalUi.getEasySteps ? pOptionalUi.getEasySteps() : [];
  const lEasyStepsSectionContainer = $('<div>')
    .addClass('machine_app_learn_more_easy_steps_section_container');
  const lEasyStepsHeader =  $('<label>')
    .addClass('machine_app_learn_more_section_header')
    .text(`${lEasySteps.length} ${pFlavorText.learnMoreModal.easyStepsHeader}:`);
  const lStepCardsContainer = $('<div>')
    .addClass('machine_app_learn_more_step_card_grid');
  const lStepCards = lEasySteps.map((pStepData, pStepIdx) => getEasyStepCard(pStepData, pStepIdx + 1, lEasyStepsSectionContainer));

  return lEasyStepsSectionContainer.append(
    lEasyStepsHeader,
    lStepCardsContainer.append(
      ...lStepCards
    )
  );

}

function getEasyStepCard(pEasyStepData, pStepNumber, pStepsContainer) {
  const lCard = $('<div>')
    .addClass('machine_app_learn_more_step_card');
  const lStepThumbnail = $('<div>')
    .addClass('machine_app_learn_more_step_thumbnail')
    .append(pEasyStepData.thumbnail);

  const lStepDescription = $('<p>')
    .addClass('machine_app_learn_more_step_description')
    .text(`${pStepNumber}. ${pEasyStepData.description}`);

  return lCard.append(
    lStepThumbnail,
    lStepDescription,
  );
}
